import { FixedSizeList, areEqual } from 'react-window'
import React from 'react'
import { DefaultCardType, ColumnType, InvestimentCardType } from '../../type'
import { Item } from '../Item/Item'
import { ItemListContainer } from './style'

type ICardList = {
  cardList: (DefaultCardType | InvestimentCardType)[]
  column: ColumnType
  onTrash?: ((id: string) => void) | false
  columnsWithTrash?: number[]
  investCard: boolean
  handleClick?: () => void
  noSpecialist?: boolean
  notDraggable?: boolean
  isEnterprise?: boolean
}

type RowProps = {
  index: number
  style: React.CSSProperties
  cardList: (DefaultCardType | InvestimentCardType)[]
  column: ColumnType
  onTrash?: ((id: string) => void) | false
  columnsWithTrash?: number[]
  investCard: boolean
  handleClick?: () => void
  noSpecialist?: boolean
  notDraggable?: boolean
  isEnterprise?: boolean
}

const Row = React.memo(
  ({
    index,
    style,
    cardList,
    column,
    onTrash,
    investCard,
    handleClick,
    noSpecialist,
    notDraggable,
    isEnterprise,
    columnsWithTrash,
  }: RowProps) => {
    const card = cardList[index]
    return (
      <div style={style}>
        <Item
          key={card.id}
          item={card}
          index={index}
          column={column}
          onTrash={onTrash}
          columnsWithTrash={columnsWithTrash}
          investCard={investCard}
          handleClick={handleClick}
          noSpecialist={noSpecialist}
          notDraggable={notDraggable}
          isEnterprise={isEnterprise}
        />
      </div>
    )
  },
  areEqual
)

export const ItemList = ({
  cardList,
  column,
  onTrash,
  investCard,
  handleClick,
  noSpecialist,
  notDraggable,
  columnsWithTrash,
  isEnterprise,
}: ICardList) => {
  return (
    <ItemListContainer className="card-list">
      <FixedSizeList
        className="fixed-list"
        height={window.innerHeight - 235}
        itemCount={cardList.length}
        itemSize={!investCard ? 150 : 350}
        width={!investCard ? 230 : 276}
      >
        {({ index, style }) => (
          <Row
            index={index}
            style={style}
            cardList={cardList}
            column={column}
            onTrash={onTrash}
            columnsWithTrash={columnsWithTrash}
            investCard={investCard}
            notDraggable={notDraggable}
            handleClick={handleClick}
            noSpecialist={noSpecialist}
          />
        )}
      </FixedSizeList>
    </ItemListContainer>
  )
}
